<div class="ea-parrainage mbl">
  <pr-panel clazz="man" class="flex-stretch">
    <pr-panel-body clazz="d-flex justify-content-center gap-xl block-sm">
      <svg-icon-sprite
        src="assets/svg/sprite.svg#card"
        viewBox="0 0 38 37"
        width="60px"
        height="60px"
      >
      </svg-icon-sprite>

      <div>
        <p class="fs-16">Gagnez 200€ pour chaque parrainage*</p>
        <p class="secondary">
          Vous recevrez 200€ lors de sa première souscription pour tout minimum
          de 10 000€
        </p>
      </div>

      <pr-button
        clazz="mtl bg-neutral-outline"
        label="Nouveau parrainage"
        (onClick)="goToParrainages()"
      ></pr-button>
    </pr-panel-body>
  </pr-panel>
</div>
